import { useTheme } from "../../styles/theme";
import { useApp } from "../../context/AppContext";
import { dispDate } from "../../utils/dates";
import { fmt } from "../../utils/format";
import { EXPENSE_CATS } from "../../utils/data";
import SectionTitle from "../../components/SectionTitle";
import Field from "../../components/Field";

export default function Expenses() {
  const S = useTheme();
  const {
    data, form, setForm, TODAY,
    addExpense, del,
    expByCategory, totalExpenses,
  } = useApp();

  return (
    <div>
      <SectionTitle>Direct Expenses — Same Day Cash</SectionTitle>
      <p style={S.tabDesc}>Materials, transport, fuel — any cash paid immediately today.</p>

      {/* Add form */}
      <div style={S.formCard}>
        <div style={S.formGrid}>
          <Field label="Description">
            <input style={S.input} placeholder="e.g. Packaging, Petrol"
              value={form.expDesc || ""}
              onChange={e => setForm({ ...form, expDesc: e.target.value })} />
          </Field>
          <Field label="Category">
            <select style={{ ...S.input, cursor: "pointer" }}
              value={form.expCat || ""}
              onChange={e => setForm({ ...form, expCat: e.target.value })}>
              <option value="">Select…</option>
              {EXPENSE_CATS.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </Field>
          <Field label="Amount (₹)">
            <input style={S.input} type="number" placeholder="0"
              value={form.expAmount || ""}
              onChange={e => setForm({ ...form, expAmount: e.target.value })} />
          </Field>
          <Field label="Date">
            <input style={S.input} type="date"
              value={form.expDate || TODAY}
              onChange={e => setForm({ ...form, expDate: e.target.value })} />
          </Field>
          <Field label="Paid To (optional)">
            <input style={S.input} placeholder="Shop / name"
              value={form.expVendor || ""}
              onChange={e => setForm({ ...form, expVendor: e.target.value })} />
          </Field>
        </div>
        <div style={{ ...S.creditNote, borderLeftColor: S.colors.purple }}>
          💸 Cash leaves hand <strong>same day</strong>
        </div>
        <button style={{ ...S.submitBtn, background: S.colors.purple }} onClick={addExpense}>
          + Add Expense
        </button>
      </div>

      {/* Category breakdown */}
      {Object.keys(expByCategory).length > 0 && (
        <>
          <SectionTitle style={{ marginTop: 24 }}>Category Breakdown</SectionTitle>
          <div style={S.categoryGrid}>
            {Object.entries(expByCategory).sort((a, b) => b[1] - a[1]).map(([cat, amt]) => (
              <div key={cat} style={S.catCard}>
                <div style={S.catName}>{cat}</div>
                <div style={{ ...S.catAmount, color: S.colors.purple }}>{fmt(amt)}</div>
                <div style={S.catBar}>
                  <div style={{ ...S.catBarFill, width: `${Math.min(100, (amt / totalExpenses) * 100)}%` }} />
                </div>
                <div style={S.catPct}>{((amt / totalExpenses) * 100).toFixed(1)}%</div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* History table */}
      <SectionTitle style={{ marginTop: 24 }}>Expense History</SectionTitle>
      <div style={S.tableWrap}>
        <table style={S.table}>
          <thead>
            <tr>
              {["Description","Category","Paid To","Amount","Date","Action"].map(h => (
                <th key={h} style={S.th}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {(data.expenses || []).length === 0 && (
              <tr><td colSpan={6} style={S.emptyCell}>No expenses yet.</td></tr>
            )}
            {(data.expenses || []).map(e => (
              <tr key={e.id} style={S.tr}>
                <td style={S.td}>{e.description}</td>
                <td style={S.td}>
                  <span style={{ ...S.typeBadge, background: S.colors.expenseBg, color: S.colors.purple }}>{e.category}</span>
                </td>
                <td style={S.td}>{e.vendor || "—"}</td>
                <td style={{ ...S.td, fontWeight: 700, color: S.colors.purple }}>{fmt(e.amount)}</td>
                <td style={S.td}>{dispDate(e.date)}</td>
                <td style={S.td}>
                  <button style={{ ...S.smallBtn, ...S.deleteBtn }} onClick={() => del("expenses", e.id)}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
